import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import AppLayout from "@/components/AppLayout";
import Inbox from "@/pages/Inbox";
import Contacts from "@/pages/Contacts";
import Students from "@/pages/Students";
import Classes from "@/pages/Classes";
import Scheduled from "@/pages/Scheduled";
import Locations from "@/pages/Locations";
import Inactive from "@/pages/Inactive";
import Dropped from "@/pages/Dropped";
import Templates from "@/pages/Templates";
import Automations from "@/pages/Automations";
import OptedOut from "@/pages/OptedOut";
import Broadcasts from "@/pages/Broadcasts";
import Staff from "@/pages/Staff";
import Absences from "@/pages/Absences";
import StaffGroup from "@/pages/StaffGroup";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/inbox" replace />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="inbox/:conversationId" element={<Inbox />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="students" element={<Students />} />
              <Route path="classes" element={<Classes />} />
              <Route path="locations" element={<Locations />} />
              <Route path="inactive" element={<Inactive />} />
              <Route path="dropped" element={<Dropped />} />
              <Route path="scheduled" element={<Scheduled />} />
              <Route path="templates" element={<Templates />} />
              <Route path="automations" element={<Automations />} />
              <Route path="opted-out" element={<OptedOut />} />
              <Route path="broadcasts" element={<Broadcasts />} />
              <Route path="absences" element={<Absences />} />
              <Route path="staff" element={<Staff />} />
              <Route path="staff-group" element={<StaffGroup />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
